import React from 'react';
import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';

export type GutterSize = 'lg' | 'md' | 'sm';

type RestrictedGridProps = Omit<MuiGridProps, 'columns' | 'columnSpacing' | 'rowSpacing' | 'spacing'>;
interface ContainerGripProps extends Omit<RestrictedGridProps, 'item'> {
  container: true;
  item?: false;

  /**
     * Manually sets the gutter size independently from the screen size
     */
  gutter?: GutterSize;
}
interface ItemGripProps extends Omit<RestrictedGridProps, 'container'> {
  item: true;
  container?: false;
}

export type GridProps = ContainerGripProps | ItemGripProps;

const defaultProps: Required<Pick<MuiGridProps, 'columns' | 'spacing'>> = {
  spacing: {
    xl: 8,
    lg: 8,
    md: 6,
    sm: 4,
    xs: 4,
  },
  columns: {
    xl: 12,
    lg: 12,
    md: 12,
    sm: 8,
    xs: 4,
  },
};

const customGutters: Record<GutterSize, number> = {
  lg: 8,
  md: 6,
  sm: 4,
};

const isContainer = (props: GridProps): props is ContainerGripProps => Boolean(props.container);

export function Grid(props: GridProps) {
  if (isContainer(props)) {
    const { gutter } = props;
    const mergedProps = {
      ...defaultProps,
      ...props,
    };
    if (gutter) {
      mergedProps.spacing = customGutters[gutter];
    }

    return <MuiGrid {...mergedProps} />;
  }

  return <MuiGrid {...props} />;
}
